import React, { useReducer, useState, useEffect, useCallback } from "react";
import { Dropdown, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import Select from "react-select";
import {
  AddService,
  GetServices,
  ActivateService,
  DisableService,
  DeleteService,
  EditService,
  GetServiceDurations,
  GetConfig,
  getCroppedImg
} from './Requests';
import {
  notifySuccess,
  notifyError
} from '../Response/ResposeHandler'
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cropper from 'react-easy-crop';

const ManageServices = () => {
  const [services, setServices] = useState([])
  const [timeSelection, setTimeSelection] = useState([])
  const [serviceImage, setServiceImage] = useState("data:image/jpeg;base64," + null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isLoading, setIsLoading] = useState(true)
  const [serviceId, setServiceId] = useState(null)
  const [serviceStatus, setServiceStatus] = useState()
  const [isEdit, setIsEdit] = useState(false);
  const [serviceName, setServiceName] = useState('');
  const [acceptOnlinePayment, setAcceptOnlinePayment] = useState(false);
  const [serviceDuration, setServiceDuration] = useState(0);
  const [servicePrice, setServicePrice] = useState(0);
  const [serviceDescription, setServiceDescription] = useState('');
  const [isAddServiceButtonLoading, setIsAddServiceButtonLoading] = useState(false);
  const [isActivateServiceButtonLoading, setIsActivateServiceButtonLoading] = useState(false);
  const [isDisableServiceButtonLoading, setIsDisbaleServiceButtonLoading] = useState(false);
  const [isDeleteServiceButtonLoading, setIsDeleteServiceButtonLoading] = useState(false);
  const [priceToPay, setPriceToPay] = useState(null);
  let errorsObj = { serviceName: '', serviceDuration: '', servicePrice: '', serviceDescription: '' };
  const [errors, setErrors] = useState(errorsObj);
  const [config, setConfig] = useState()
  const [payMin ,setPayMin] = useState(0)
  const [payMax, setPayMax] = useState()
  const [payReturn, setPayReturn] = useState(0)
  const initialState = false;

  const reducer = (state, action) =>{
	switch (action.type){
		case 'addServiceOpen':
			return { ...state, sendMessage: true }
		case 'addServiceClose':			
			return { ...state, sendMessage: false }		
			
		default:
        return state	
	}	
}

useEffect(() => {
  GetServicesWrapper()
  GetServiceDurationsWrapper()
}, []);

const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: state.isFocused ? "#525252" : "#7e7e7e",
});

const ClearIndicator = (props) => {
  const {
  getStyles,
  innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
    >
        <div style={{ padding: "0px 5px" }}>Clear</div>
    </div>
  );
};

  const [state, dispatch] = useReducer(reducer, initialState);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

    const handleCropDone = async () => {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      setServiceImage(croppedImage);

      // Reset cropping state
      setImageSrc(null);
    };
  
    const handleCropCancel = () => {
    setImageSrc(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  function onSubmitClick(e) {
    console.log('add')
    e.preventDefault();

    let error = false;
    const errorObj = { ...errorsObj };
    if (serviceName === '') {
        errorObj.serviceName = 'Name is required';
        error = true;
    }
    console.log(serviceDuration)
    if (serviceDuration === null || serviceDuration === undefined) {
      errorObj.serviceDuration = 'Duration is required';
      error = true;
    } else {
      if (serviceDuration.value === 0 || serviceDuration.value === null || serviceDuration.value === '') {
        errorObj.serviceDuration = 'Duration is required';
        error = true;
      }
    }
    if (servicePrice === '' || servicePrice === null || servicePrice < 0) {
      errorObj.servicePrice = 'Price is required';
      error = true;
    }
    if (serviceDescription === '') {
      errorObj.serviceDescription = 'Description is required';
      error = true;
    }
    setErrors(errorObj);
    if (error) {
  return;
} else {
  setIsAddServiceButtonLoading(true)
}

var serviceImageFile = base64ToFile(serviceImage, "serviceImage.jpg")

if (isEdit) {
  EditService(serviceId, serviceName, serviceDuration.value, servicePrice, serviceDescription, serviceStatus, acceptOnlinePayment, priceToPay*100, serviceImage === "data:image/jpeg;base64,null" ? null : serviceImageFile).then((res) => {
    notifySuccess("Service Edited")
    dispatch({type:'addServiceClose'})
    GetServicesWrapper()
  }).catch((error) => {
    notifyError("Unable to edit service, please try again")
  }).finally((f) => {
    setIsAddServiceButtonLoading(false)
  })
} else {
  AddService(serviceName, serviceDuration.value, servicePrice, serviceDescription, acceptOnlinePayment, priceToPay*100, serviceImage === "data:image/jpeg;base64,null" ? null : serviceImageFile).then((res) => {
    notifySuccess("Service added")
    dispatch({type:'addServiceClose'})
    GetServicesWrapper()
  }).catch((error) => {
    notifyError("Unable to add service, please try again")
  }).finally((f) => {
    setIsAddServiceButtonLoading(false)
  })
}
}

function base64ToFile(base64Data, filename) {
  const arr = base64Data.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

  function handleInputChange(e) {
    console.log("max = " + servicePrice)
    console.log(e.target.value)
    let newValue = parseFloat(e.target.value);
    console.log(newValue)
    if (isNaN(newValue)) newValue = 0.20;
    if (newValue < 0.20) newValue = 0;
    if (newValue > payMax) newValue = payMax;
    setPriceToPay(newValue);
    // setPriceToPay(Number(parseFloat(e.target.value)).toFixed(2))
    // setPayReturn(Math.abs(Number((newValue) - (((newValue*1.5)/100)+(0.20))).toFixed(2)))
  };

  function handleSliderChange(e){
    setPriceToPay(parseFloat(e.target.value));
    setPayReturn(Math.abs(Number((parseFloat(e.target.value)) - (((parseFloat(e.target.value)*1.5)/100)+(0.20))).toFixed(2)))
  };

function OnDisableService(serviceId, name, description, duration, price) {
  setIsDisbaleServiceButtonLoading(true)
  DisableService(serviceId, name, description, duration, price).then((res) => {
    notifySuccess("Service disabled")
    GetServicesWrapper()
  }).catch((error) => {
    notifyError("Unable to disable service, please try again")
  }).finally((f) => {
    setIsDisbaleServiceButtonLoading(false)
  })
}

function OnActivateService(serviceId, name, description, duration, price) {
  setIsActivateServiceButtonLoading(true)
  ActivateService(serviceId, name, description, duration, price).then((res) => {
    notifySuccess("Service activated")
    GetServicesWrapper()
  }).catch((error) => {
    notifyError("Unable to activate service, please try again")
  }).finally((f) => {
    setIsActivateServiceButtonLoading(false)
  })
}

function OnDeleteService(serviceId, name, description, duration, price) {
  setIsDeleteServiceButtonLoading(true)
  DeleteService(serviceId, name, description, duration, price).then((res) => {
    notifySuccess("Service removed")
    GetServicesWrapper()
  }).catch((error) => {
    notifyError("Unable to remove service, please try again")
  }).finally((f) => {
    setIsDeleteServiceButtonLoading(false)
  })
}

function OnEditService(serviceId, name, description, duration, price, status, acceptOnlinePayment, priceToPay, image) {

  console.log(image)
  console.log(acceptOnlinePayment)
  setServiceId(serviceId)
  setIsEdit(true)
  setAcceptOnlinePayment(acceptOnlinePayment)
  setServiceName(name)
  setServiceDescription(description)
  setServiceDuration(timeSelection.filter(item => item.value === duration)[0])
  setServicePrice(price)
  setServiceStatus(status)
  setPriceToPay(Number(priceToPay/100).toFixed(2))
  setPayMax(parseFloat(price))
  setServiceImage("data:image/jpeg;base64," + image)
}

function GetServicesWrapper() {
  setIsLoading(true)
  GetServices().then((res) => {
    console.log(res.data)
    setServices(res.data)
  }).catch((error) => {
    notifyError("Unable to retrieve services, please try again")
  }).finally(() => {
    GetConfigWrapper()
  })
}

  function GetConfigWrapper() {
    GetConfig().then((res) => {
      console.log(res.data)
      setConfig(res.data)

    }).catch((error) => {
    }).finally(() => {
      setIsLoading(false)
    })
  }

function GetServiceDurationsWrapper() {
  GetServiceDurations().then((res) => {
    setTimeSelection(res.data)
  }).catch((error) => {
    notifyError("Unable to retrieve service durations, please try again")
  })
}

function resetModal() {
  setIsEdit(false)
  setServiceName('');
  setAcceptOnlinePayment(false)
  setServiceDuration(null);
  setServicePrice(null);
  setServiceDescription('');
  setErrors(errorsObj);
  setPriceToPay(null)
  setPayMax()
  setPayReturn(0)
  setServiceImage("data:image/jpeg;base64," + null)
}

  const handleImageChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImageSrc(imageUrl);
    }
  };

  function DeleteServiceImage(e)
  {
    e.preventDefault();
    setServiceImage("data:image/jpeg;base64," + null)
  }
  
  return (
      <div className="h-80">
        {/* <PageTitle activeMenu="Mange Services" motherMenu="Barber Shop" /> */}
        <div className="mb-2" style={{display: 'grid', justifyContent: 'end'}}>
            <Link to={"#"} className="btn-custom btn-primary mb-1 ms-1" onClick={() =>{ dispatch({type:'addServiceOpen'}); resetModal();}}>Add Service</Link>	
        </div>
        <ToastContainer />
        <div className="row">
            <div className="col-lg-12">
              <div className="card">
                  <div className="card-body ">
								<div tabindex="-1" className="profile-statistics">
                  {isLoading ? <></>
                  :
                  
                <Modal tabindex="-1" className="modal fade" show={state.sendMessage} centered>
									<div className="modal-content">
									  <div className="modal-header">
										<h5 className="modal-title">{isEdit ? 'Edit Service' : 'Add Service'}</h5>
										<Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'addServiceClose'}); resetModal();}}>
										  
										</Button>
									  </div>
									  <div className="modal-body">
										<form className="comment-form">
										  <div className="row">
											<div className="col-lg-6">
											  <div className="form-group mb-3">
												<label htmlFor="author" className="service-modal-label">  Service Name <span className="required">*</span> </label>
												<input
                          type="text"
                          className="form-control"
                          name="serviceName"
                          placeholder=""
                          value={serviceName}
                          onChange={(e) => setServiceName(e.target.value)} />
                          {errors.serviceName && <div className="mt-2 text-danger fs-12">{errors.serviceName}</div>}
											  </div>
											</div>
											<div className="col-lg-6">
											  <div className="form-group mb-3">
												<label htmlFor="email" className="service-modal-label"> Service Duration <span className="required">*</span></label>
                          <Select
                            closeMenuOnSelect={true}
                            components={{ ClearIndicator }}
                            styles={{ clearIndicator: ClearIndicatorStyles }}
                            // isMulti
                            defaultValue={serviceDuration}
                            options={timeSelection}
                            onChange={(e) => setServiceDuration(e)}
                          />
                          {errors.serviceDuration && <div className="mt-2 text-danger fs-12">{errors.serviceDuration}</div>}
											  </div>
											</div>
                      <div className="col-lg-6">
											  <div className="form-group mb-3">
												<label htmlFor="email" className="service-modal-label"> Service Price (£) <span className="required">*</span></label>
												<input
                          type="number"
                          className="form-control"
                          placeholder=""
                          name="servicePrice"
                          defaultValue={servicePrice===null ? null : Number(servicePrice/100).toFixed(2)}
                          onChange={(e) => setServicePrice(e.target.value*100)}/>
                          {errors.servicePrice && <div className="mt-2 text-danger fs-12">{errors.servicePrice}</div>}
											  </div>
											</div>
											<div className="col-lg-12">
											  <div className="form-group mb-3">
												<label htmlFor="comment" className="service-modal-label">Description</label>
												<textarea
                          rows={3}
                          className="form-control"
                          name="serviceDescription"
                          placeholder=""
                          value={serviceDescription}
                          maxLength={50}
                          onChange={(e) => setServiceDescription(e.target.value)}/>
                          {errors.serviceDescription && <div className="mt-2 text-danger fs-12">{errors.serviceDescription}</div>}
											  </div>
											</div>
											<div className="col-lg-12">
											  <div className="form-group mb-3">
												<label htmlFor="comment" className="service-modal-label">Image</label>
                        <div className="image-preview service-image-preview">
                          {serviceImage !== "data:image/jpeg;base64,null" ? <img src={serviceImage} alt="service" /> : null}
                        </div>
                        <div style={{display:"flex", alignItems:"center"}}>
                        <label style={{marginRight:"0.5rem"}} className="upload-button">
                          Upload Logo
                          <input type="file" accept="image/*" onChange={(e) => {handleImageChange(e, 'logo'); e.target.value = null}} />
                        </label>
                        <button onClick={DeleteServiceImage} className="upload-button cancel-button mt-2">
                            Delete
                        </button>
                        </div>
											  </div>
											</div>
                      <div className="col-lg-12 mt-4">
                        <h3 className="heading-three">Online Payments</h3>
                        <div className="stripe-toggle-row">
                          <label className={!config.acceptOnlinePayments ? "service-modal-label-disabled": "service-modal-label"}>Accept Online Payments for this service</label>
                          {/* <label style={{marginLeft:"1rem"}} className="switch-payment-service">
                            <input
                            className=""
                              type="checkbox"
                              defaultChecked={!config.acceptOnlinePayments ? false : acceptOnlinePayment}
                              disabled={!config.acceptOnlinePayments}
                              onChange={(e) => {setAcceptOnlinePayment(e.target.checked)}}
                            />
                            <span className={!config.acceptOnlinePayments ? "slider-payment-service-disabled round" : "slider-payment-service round"}></span>
                          </label> */}
                                                    <div style={{marginRight:"2rem", marginBottom:"1rem"}} className="live-switch-wrapper">
                    <input
                        className="toggle-switch"
                        type="checkbox"
                        defaultChecked={!config.acceptOnlinePayments ? false : acceptOnlinePayment}
                        disabled={!config.acceptOnlinePayments}
                        id="logon"
                        onChange={(e) => {setAcceptOnlinePayment(e.target.checked)}}
                    />
                    <label htmlFor='logon' className="switch-label"/>
                </div>
                        </div>
                      </div>
                      {acceptOnlinePayment ?
                      <div className="col-lg-12 mt-2">
                        <div>
                          <label className="service-modal-label mb-3">How much would you like to charge at time of booking</label>

                          <div className="input-slider-wrapper">
                            <input
                              type="number"
                              className="number-input"
                              value={priceToPay === 0 ? 0.20 : Number(priceToPay).toFixed(2)}
                              onChange={handleInputChange}
                              min={0.20}
                              max={servicePrice/100}
                              step={0.20}
                            />
                            <input
                            style={{padding:0}}
                              type="range"
                              className="slider-service"
                              value={priceToPay===null?0:priceToPay}
                              onChange={handleSliderChange}
                              min={0.20}
                              max={servicePrice/100}
                              step={0.10}
                            />
                          </div>
                          <p className="mt-2">After stripe fees, you will recieve £{payReturn} <br></br><p style={{fontSize:"0.9rem"}}>Stripe fees are 1.5% + £0.20</p></p>
                        </div>
                      </div>
                      :
                      <></>
                      }

											<div className="col-lg-12 mt-4">
                        <div className="form-group mb-3" style={{display:'flex', justifyContent:'end'}}>
                            {isAddServiceButtonLoading
                            ?
                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            :
                            // <input type="submit" value={isEdit? 'Edit Service' : 'Add Service'} className="submit btn btn-primary" name="submit"/>
                            <Link to={"#"} className="mt-2 btn-custom btn-primary" onClick={onSubmitClick}>{isEdit ? 'Edit Service' : 'Add Service'}</Link>
                            }
                        </div>
											</div>
										  </div>
										</form>
									  </div>
									</div>
                                    {imageSrc && (
        <div className="cropper-modal">
          <div className="cropper-wrapper">
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={400/500}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
            <div className="crop-controls">
                <button className="upload-button" onClick={handleCropDone}>
                    Crop
                </button>
                <button className="upload-button cancel-button" onClick={handleCropCancel}>
                    Cancel
                </button>
            </div>
          </div>
        </div>
      )}
								  </Modal>
                  }
                </div> 
                {isLoading ? <div className='barber-loader'></div>:
                services.length === 0 ? <div>No Services</div> :
                  <div className="table-responsive-sm">
                  <table className="table table-sm mb-0 text-black">
                    <thead>
                        <tr>
                          <th className="align-middle ps-2">Service Name</th>
                          <th className="align-middle ps-2">Service Duration</th>
                          <th className="align-middle ps-5">Price</th>
                          <th className="align-middle ps-5">Online Payment</th>
                          <th className="align-middle ps-4">Status</th>
                          <th className="align-middle text-end">Action</th>
                        </tr>
                    </thead>
                    <tbody id="orders">
                      {services === null ? <p>loading</p> :
                        services.map((service, index) => {
                          return(
                            <tr key={service.serviceId} className="btn-reveal-trigger">
                            <td className="py-2">{service.name}</td>
                            <td className="py-2">{service.timeLabel}</td>
                            {/* <td className="py-2" style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth:'1rem'}}>{service.description}</td> */}
                            <td className="py-2 ps-5">£{Number(service.price/100).toFixed(2)}</td>
                            <td className="py-2 ps-5">{!service.acceptOnlinePayment ? "-" : "£"+Number(service.onlinePaymentAmount/100).toFixed(2)}</td>
                            <td className="py-2 ps-4 align-middle">
                                <span className={`badge badge-sm light ${ service.status === 1 ? 'badge-success' : 'badge-danger'} `}>
                                  {service.status === 1 ? 'Active' : 'Disabled'}
                                </span>
                            </td>
                            <td className="py-2 text-end">
                                <Dropdown className="dropdown text-sans-serif">
                                  <Dropdown.Toggle
                                      variant=""
                                      className="btn btn-primary tp-btn-light sharp i-false"
                                      type="button"
                                      id="order-dropdown-0"
                                      data-toggle="dropdown"
                                      data-boundary="viewport"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                  >
                                      <span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="18px"
                                            height="18px"
                                            viewBox="0 0 24 24"
                                            version="1.1"
                                        >
                                            <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                              <rect y={0} width={24} height={24}/>
                                              <circle fill="#000000" cx={5} cy={12} r={2}/>
                                              <circle fill="#000000" cx={12} cy={12} r={2}/>
                                              <circle fill="#000000" cx={19} cy={12} r={2}/>
                                            </g>
                                        </svg>
                                      </span>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu
                                      className="dropdown-menu dropdown-menu-right border py-0"
                                      aria-labelledby="order-dropdown-0"
                                  >
                                      <div className="py-2">
                                        {service.status === 1 ?
                                          isDisableServiceButtonLoading ? <span style={{marginLeft:'1rem'}} className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> :
                                          <Link to={''} onClick={() => {OnDisableService(service.serviceId, service.name, service.description, service.duration, service.price);}} className="dropdown-item">Disable</Link>
                                          :
                                          isActivateServiceButtonLoading ? <span style={{marginLeft:'1rem'}} className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> :
                                          <Link onClick={() => {OnActivateService(service.serviceId, service.name, service.description, service.duration, service.price);}} className="dropdown-item">Active</Link>}
                                        <Link to={''} className="dropdown-item" onClick={() => {dispatch({type:'addServiceOpen'}); OnEditService(service.serviceId, service.name, service.description, service.duration, service.price, service.status, service.acceptOnlinePayment, service.onlinePaymentAmount, service.serviceImage);}}>Edit</Link>
                                        <div className="dropdown-divider" />
                                        {isDeleteServiceButtonLoading ? <span style={{marginLeft:'1rem'}} className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> :
                                        <Link to={''} onClick={() => {OnDeleteService(service.serviceId, service.name, service.description, service.duration, service.price);}} className="dropdown-item text-danger">Delete</Link>}
                                      </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                            </td>
                          </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
              </div>
                }
                  </div>
              </div>
            </div>
        </div>
      </div>
  );
};

export default ManageServices;
